import * as Yup from 'yup';

import { QuotationHeaderSchema } from '../../QuotationHeader/schemas/quotation-header.schema';

export const ResolvableMissionTypeQuotationHeaderSchema = Yup.object().shape({
  quotationHeader: QuotationHeaderSchema,
});
